<mat-grid-list cols="1" rowHeight="35px">
  <mat-grid-tile rowspan="1">
    <h1 class="title">Variables</h1>
  </mat-grid-tile>
  <mat-grid-tile rowspan="2">
    <button mat-raised-button color="accent" (click)="openCreate()" style="margin-right: 10px" appPermissionControl="P202B0001"><mat-icon>add</mat-icon> Nuevo</button>
    <button mat-raised-button color="accent" (click)="close()" appPermissionControl="P202B0002"><mat-icon>close</mat-icon> Cerrar</button>
  </mat-grid-tile>
  <mat-grid-tile rowspan="2">
    <mat-form-field color="accent" appearance="outline">
      <mat-label>Buscar</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Ej. Promocional" #input appPermissionControl="P202K0001" />
      <mat-icon matSuffix color="accent">search</mat-icon>
    </mat-form-field>
  </mat-grid-tile>
</mat-grid-list>

<div id="div" class="mat-elevation-z8 table-responsive">
  <table mat-table [dataSource]="dataSource" matSort appPermissionControl="P202T0001">
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P202C0001">Acciones</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu" appPermissionControl="P202B0003">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button (click)="openUpdate(element)" mat-menu-item appPermissionControl="P202B0004">
            <mat-icon>edit</mat-icon>
            <span>Editar</span>
          </button>
          <button (click)="delete(element)" mat-menu-item appPermissionControl="P202B0005">
            <mat-icon>delete</mat-icon>
            <span>Eliminar</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <ng-container matColumnDef="clavePerfil">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P202C0002">Clave</th>
      <td mat-cell *matCellDef="let element">
        {{ element.clavePerfil }}
      </td>
    </ng-container>

    <ng-container matColumnDef="tabla">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P202C0003">Archivo</th>
      <td mat-cell *matCellDef="let element">
        {{ element.tabla }}
      </td>
    </ng-container>

    <ng-container matColumnDef="tipo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P202C0004">Tipo</th>
      <td mat-cell *matCellDef="let element">
        {{ element.tipo }}
      </td>
    </ng-container>

    <ng-container matColumnDef="campo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P202C0005">Campo</th>
      <td mat-cell *matCellDef="let element">
        {{ element.campo }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="20">
        <span *ngIf="allData > 0">No hay resultados para "{{ input.value }}"</span>
        <span *ngIf="allData == 0 && !loading">No hay datos para mostrar</span>
        <mat-spinner *ngIf="loading" class="spinner"></mat-spinner>
      </td>
    </tr>
  </table>
  <mat-paginator [pageSizeOptions]="[5, 10, allData]" showFirstLastButtons class="paginatorTb"></mat-paginator>
</div>
